import Modal from "@/components/ui/Modal";
import VideoPlayerV3 from "@/components/ui/VideoPlayerV3";
import { useState } from "react";
import RequestForPrimaryVideoModal from "./modals/RequestForPrimaryVideoModal";
import FileUploadFieldPlus from "@/components/ui/FileUploadFieldPlus";
import { FileDetails } from "@/types/types";
import { TProfileVideo } from "@/redux/feature/user/userType";
import usePolling from "@/hooks/usePolling";
import { useGetVideoChangeStatusQuery } from "@/redux/feature/user/userApi";
import { useGlobalContext } from "@/context/GlobalContext";

const VideoPortfolio = ({ videos }: { videos: TProfileVideo[] }) => {
  const [playingVideoUrl, setPlayingVideoUrl] = useState("");
  const [isRequestPrimaryOpen, setIsRequestPrimaryOpen] = useState(false);

  const handlePlayVideo = (url: string) => {
    setPlayingVideoUrl(url === playingVideoUrl ? "" : url);
  };

  const handleRequestPrimaryVideoChange = () => {
    setIsRequestPrimaryOpen(true);
  };

  const { userData } = useGlobalContext();

  const { pollingInterval } = usePolling({
    templateIds: ["video_change_request_approved"],
  });
  const { data: RequestData } = useGetVideoChangeStatusQuery(userData?.email, {
    skip: !userData?.email,
    pollingInterval,
  });

  return (
    <>
      <div className="w-full sm:w-[69%] mx-auto lg:mx-0">
        <div className="flex justify-between items-center mb-8">
          <div className="space-y-2.5">
            <h5 className="text-lg leading-5 tracking-[-1%] font-semibold">
              Video Portfolio
            </h5>
            <p className="text-[#475467] leading-5 max-w-[30ch]">
              Showcase your work with video content that highlights your
              expertise
            </p>
          </div>
          <button
            onClick={handleRequestPrimaryVideoChange}
            className="px-3 py-2 text-xs font-medium text-[#344054] bg-white border border-[#D0D5DD] rounded-lg hover:bg-[#F9FAFB] hover:border-[#B2B7C2] transition-colors duration-200 whitespace-nowrap"
          >
            Request for primary Video Change
          </button>
        </div>

        <div className="bg-white rounded-lg border border-[#E4E7EC] p-6">
          <div className="flex items-center flex-wrap gap-4">
            {/* videos */}
            {videos?.map((video, i) => (
              <div key={i} className="relative group">
                <div className="relative">
                  {video.isActive && (
                    <div className="absolute top-2 left-2 z-50 bg-[#16A34A] text-white text-[10px] font-medium px-1.5 py-0.5 rounded-md">
                      Primary
                    </div>
                  )}
                  {/* <div className="absolute top-2 right-2 z-10 bg-black/70 text-white text-[10px] font-medium px-1.5 py-0.5 rounded-md">
                    {video.duration}
                  </div> */}
                  <div className="h-[290px] w-[165px] bg-[#F2F4F7] rounded-lg overflow-hidden">
                    <VideoPlayerV3
                      url={video.video.live_url as string}
                      thumbnailUrl={video.thumbnail}
                      playing={playingVideoUrl === video.video.live_url}
                      muted={false}
                      blurhash={video.hash}
                      onPlay={() =>
                        handlePlayVideo(video.video.live_url as string)
                      }
                      border="rounded-lg"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* No videos placeholder */}
          {videos?.length === 0 && (
            <div className="text-center py-8">
              <div className="w-10 h-10 mx-auto mb-3 bg-[#F2F4F7] rounded-lg flex items-center justify-center">
                <svg
                  className="w-5 h-5 text-[#667085]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h6 className="text-sm font-medium text-[#101828] mb-1">
                No videos uploaded yet
              </h6>
              <p className="text-xs text-[#667085] mb-3">
                Upload your first video to showcase your work
              </p>
              <button className="px-3 py-2 text-xs font-medium text-white bg-[#101828] rounded-lg">
                Upload Video
              </button>
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={isRequestPrimaryOpen}
        setOpen={setIsRequestPrimaryOpen}
        width="700px"
      >
        <RequestForPrimaryVideoModal
          RequestData={RequestData}
          setIsRequestPrimaryOpen={setIsRequestPrimaryOpen}
          videos={videos}
        />
      </Modal>
    </>
  );
};

export default VideoPortfolio;
